import type { FaireProductEntity } from "../../entity_types/product";

export const p_2tyv2scs4s: FaireProductEntity = {
  token: "p_2tyv2scs4s",
  type: "product",
  name: "MVP Bundle!",
  brandToken: "b_vjrx63e348",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/4fd0507fa39b3a4bc8a3b9d31f0e897ee063532cac2814a85f5f1f8f17bf17a6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/023b0ad1f7f8ef6c67690c33911c1dccd891eed3dcdd2b19ea644c62249fe79c.png",
    "https://cdn.faire.com/fastly/5efeda0d553fee4c5816af30296ecf959052b531815dd153421f6e4d7ae33014.jpeg",
    "https://cdn.faire.com/fastly/8e56579916950153cfece17578882b52b46cd2bcc4d97d450795a3db822cd0a0.png",
    "https://cdn.faire.com/fastly/44ce4b323dc079458d3868694b9cf5098979d5c536c3b91c13d518ca8f568efa.png",
  ],
  priceDollars: 124.5,
  description:
    "\nThis bundle is your all-in-one daily performance system. Whether you're hitting the gym, chasing your kids, or grinding through long workdays. Each product plays its role, but together? They work in synergy to elevate how you feel, function, and show up every single day. SAVE $42 HERE\n\nOptimize Minerals replenishes your body with essential minerals and water soluble vitamins, lacking in our food, lost through sweat, stress, and daily life. This synergistic blend offers a wide range of benefits from gut health, energy, inflammation, hormones and more. \n\nOptimize Vitaminz fills the nutritional gaps most people don’t even know they have. With bioavailable vitamins and antioxidant support, it helps balance hormones, support liver and organ function, boost immunity, and sharpen your mental clarity.",
  tags: [],
  msrpDollars: 249,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:15.598Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
